import React, { useEffect, useState } from "react";
import { DialogBox } from "../../shared/components/dialog";
import { DialogContent, FormHelperText, Stack, TextField, Button, Box, Typography } from "@mui/material";

import { useArcAuth } from "@arcauth/react-sdk";
import { useDispatch, useSelector } from "react-redux";
import { getPhoneEmailExists, getUserInfo, updateUserInfo } from "../../redux/features/user.slice";
import { RootStateType } from "../../redux/features/rootSlice";
import { emailRegex, sixDigitOTPRegex } from "../../shared/util/authentication.regex";
import { MESSAGES, webSocketMessage } from "../../config/app";
import { getSecurityCode } from "../../redux/features/auth.slice";
import useCountdownTimer from './../../hooks/useCountdownTimer';
import { ButtonComponent } from "../../shared/components/button";
import useWebSocket from "../../hooks/useWebSocket";

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  user?: {
    id: string;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    newpassword: string;
    oldpassword: string;
    language: string;
    timezone: string;
  };
}
const EmailUpdate = (props: DialogProps) => {
  const { open, onClose, user } = props;
  const { timeLeft, resendButtonEnabled, resetTimer } = useCountdownTimer(180); // 3 minutes
  const dispatch = useDispatch();
  const { updateUserAndNotifyParent } = useWebSocket();
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [email, setEmail] = useState("");
  const [emailHelperText, setEmailHelperText] = useState("");
  const [emailCode, setEmailCode] = useState(false);
  const [securityCode, setSecurityCode] = useState("");

  const emailUpdate_loading = useSelector(
    (state: RootStateType) => state.userStateReducer.loading
  );
  const code_loading = useSelector(
    (state: RootStateType) => state.authStateReducer.loading
  );
  const configData:any = useSelector((state:RootStateType)=>state.configStateReducer.clientConfig);
  const dialogClose = () => {
    setEmailCode(false);
    resetTimer();
    onClose();
  };
  const validateEmailAndSendCode = () => {
    const dispatchObj = {
      params: { email },
      callBackSuccess: () => {
        reSendCode()
      },
      callBackFailure: () => {
        setButtonEnabled(false);
      },
    };
    dispatch(getPhoneEmailExists(dispatchObj));
  };
  
  const reSendCode = () => {
  const sendCodeObj = {
    body: {
      email,
      applicationid: configData?.applicationId,
    },
    callBackSuccess: () => {
      setEmailCode(true);
      resetTimer();
      setSecurityCode("");
      setButtonEnabled(false);
    },
    callBackFailure: () => {
      setButtonEnabled(false);
    },
  };
    dispatch(getSecurityCode(sendCodeObj));
  };

  const handleListItemClick = async () => {
    setEmailCode(true); 
    const dispatchObj = {
      user: {
        email,
        code: securityCode,
        applicationid: configData?.applicationId,
      },
      successMessage: MESSAGES.emailSuccess,
      callBackSuccess: () => {
        updateUserAndNotifyParent(webSocketMessage.emailResponse);
        onClose();
        setEmailCode(false);
        setSecurityCode("");
        dispatch(getUserInfo());
        setButtonEnabled(false);
      },
      callBackFailure: () => {
        setButtonEnabled(false);
      },
    }; 
    dispatch(updateUserInfo(dispatchObj));
  };
  

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      handleListItemClick();
    }
  };
  const handleKeyDownCode = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      validateEmailAndSendCode();
    }
  };
  useEffect(() => {
    setEmail(user?.email ?? "");
  }, [user]);


  useEffect(() => {
    if (email == "") {
      setButtonEnabled(false);
      setEmailHelperText("Email cannot be empty");
    } else {
      if (email != user?.email && emailRegex.test(email)) {
        setEmailHelperText("");
        setButtonEnabled(true);
      } else {
        setButtonEnabled(false);
        setEmailHelperText("Invalid email");
      }
      if (email == user?.email) setEmailHelperText("");
    }
  }, [email]);

  useEffect(() => {
    if (securityCode === "") {
      setButtonEnabled(false);
      //setEmailHelperText("Email cannot be empty");
    } else if (securityCode.length === 6 && sixDigitOTPRegex.test(securityCode)) {
      setEmailHelperText("");
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
      //setEmailHelperText("Invalid code");
    }
  }, [securityCode]);
  

  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Update email"}
        buttonText={emailCode? 'Update': 'Continue'}
        buttonClick={emailCode? handleListItemClick : validateEmailAndSendCode}
        isLoading ={emailCode ? emailUpdate_loading : emailUpdate_loading || code_loading}
        isBtnEnabled={!buttonEnabled}
        open={open}
        style={{ maxWidth: 500, mx: "auto" }}
      >
        <DialogContent>
          <Stack>
          {!emailCode? 
          <><label htmlFor="" style={{fontSize: 13}}>Email</label><TextField
                size="small"
                fullWidth
                autoFocus
                // label="Email"
                value={email ?? ""}
                placeholder="Enter email"
                color="secondary"
                inputProps={{ maxLength: 100 }}
                onKeyDown={handleKeyDownCode}
                onChange={(e) => {
                  setEmail(e.target.value);
                } } /></>
            :
            <>
            <Typography variant="body1" color="initial" textAlign={'center'} gutterBottom>
              Please share the 6-digit security code sent to {email}</Typography>
              <label htmlFor="">Security code</label>
            <TextField
              size="small"
              fullWidth
              autoFocus
              // label="Security code"
              value={securityCode ?? ""}
              placeholder="Enter Security code"
              color="secondary"
              inputProps={{ maxLength: 6 }}
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                setSecurityCode(e.target.value);
              }}
            />
                <Stack direction={'row'} justifyContent={"space-between"} alignItems="center">
                  <Box>{timeLeft}</Box>
                   <ButtonComponent buttonName="Resend" variant="text" color="secondary" onClickHandle={()=>{
                    resetTimer();
                    reSendCode();
                  }} isBtnEnabled={!resendButtonEnabled} isLoading={code_loading}/>
                </Stack>
            </>
}
            <FormHelperText
              style={{
                color: "red",
              }}
            >
              {emailHelperText}
            </FormHelperText>
          </Stack>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default EmailUpdate;
